/**
 * Construct the XPath of the target element. We're using XPath so we can
 * share the unique element, regardless of it's attributes. Allows us to
 * evaluate specific elements despite them not having unique identifiers.
 *
 * * https://developer.mozilla.org/en-US/docs/Web/XML/XPath
 *
 * @param {Element} element - The target element to get the path for.
 * @returns string - the XPath result, or empty string if invalid.
 */
const getPathTo = (element: Element): string => {
  if (element.id !== '') return `id("${element.id}")`;
  if (element === document.body) return element.tagName;
  if (!element.parentElement) return '';

  let ix = 0;
  const siblings = element.parentElement.children;
  for (let i = 0; i < siblings.length; i++) {
    const sibling = siblings[i];
    if (sibling === element) {
      return `${getPathTo(element.parentElement)}/${element.tagName}[${ix + 1}]`;
    }

    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) ix++;
  }

  return '';
};

export { getPathTo };
